import { render, staticRenderFns } from "./ForgetPasswordDrawer.vue?vue&type=template&id=153a9d07&scoped=true&"
import script from "./ForgetPasswordDrawer.vue?vue&type=script&lang=js&"
export * from "./ForgetPasswordDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ForgetPasswordDrawer.vue?vue&type=style&index=0&id=153a9d07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153a9d07",
  null
  
)

export default component.exports